// เช็คสต๊อกสินค้า 
import axios from 'axios'
import { genURL } from "../../_getjson";
export default async function ChkStock(productcode, provenance, unitcode, warehouse, location, maingroup, getcountstocktype) {
    let urlCountstock = "CSPRODUCT/GetcountStock?productcode=" + productcode + "&getcountstocktype=" + (typeof getcountstocktype !== "undefined" ? getcountstocktype : "") + "&provenance=" + provenance + "&unitcode=" + unitcode + "&warehouse=" + warehouse + "&location=" + location
    console.log("ChkStock", genURL(urlCountstock));
    let SaleStock = ""
    // if (maingroup <= 2) {
    await axios.get(genURL(urlCountstock), { timeout: 3600 }).then((resCountstock) => {
        try {
            SaleStock = resCountstock.data[0].SaleStock
        } catch (error) {
            console.log("err", console.error());
            SaleStock = 0
        }
    })
    // }
    console.log("ChkStock", SaleStock);
    return Promise.resolve(SaleStock)
}